module.exports = __webpack_public_path__ + "img/dagobah3.0cd75e7f.png";